import type { EventTrackingParam } from '@/services/eventTracking/types';

import { signInEvent } from './constants';
import type { SignInGetResponse, SignInOpenPage } from './types';

export function signInOpenPage(
  params: SignInOpenPage
): EventTrackingParam {
  return {
    event: signInEvent.openPage,
    eventProps: {
      page_name: 'sign_in_form',
      ...params
    }
  };
}

export function signInGetResponse(
  params: SignInGetResponse
): EventTrackingParam {
  return {
    event: signInEvent.getResponse,
    eventProps: {
      ...params
    }
  };
}
